import { palette, PaletteColors, spacing } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

interface Props {
  style?: StyleProp<ViewStyle>;
  color?: PaletteColors;

  children?: React.ReactNode;
}

const Box: FC<Props> = (props) => (
  <View
    style={StyleSheet.flatten([
      styles.box,
      props.style,
      { backgroundColor: props.color || palette.white },
    ])}
  >
    {props.children}
  </View>
);

// Styles
const styles = StyleSheet.create({
  box: {
    padding: spacing[6],
    borderRadius: 20,
  },
});

export default Box;
